<template>
    <v-tooltip-wrapper
        :max-width="330"
        :nudge-bottom="2"
        :open-delay="150"
        content-class="tooltip-glass tooltip-white elevation-8 tooltip-border-colored tooltip-border-sizenotmatching">
        <template #activator="{ on, attrs }">
            <i class="far fa-triangle-exclamation color-size-not-matching-icon"
               v-bind="{...$attrs, ...attrs}"
               v-on="{...$listeners, ...on}" />
        </template>
        <span v-html="t_size_not_matching" />
    </v-tooltip-wrapper>
</template>

<script>
import VTooltipWrapper from '../../common/v-tooltip-wrapper.vue'

export default {
    components: { VTooltipWrapper },
    inheritAttrs: false,
    inject: {
        /** @type {PublishInjectInfoTable} */
        publishInfoTable: {
            default: {}
        },
        /** @type {PublishInjectInfoRaw} */
        publishInfoRaw: {
            default: {}
        }
    },
    props: {
        /** @type {PublishElementData} */
        data: Object,
        /** @type {PublishLayer} */
        layer: Object
    },
    computed: {
        t_size_not_matching() {
            return Lang.langGet('The size of the element (:elementsize) does not match the size of the layer (:layersize).', {
                layersize: `<b>${this.layerComputed?.width}x${this.layerComputed?.height}</b>`,
                elementsize: `<b>${this.dataComputed?.width}x${this.dataComputed?.height}</b>`
            })
        },
        dataComputed() {
            return this.data ?? this.publishInfoTable?.element?.data ?? this.publishInfoRaw?.element?.data
        },
        layerComputed() {
            return this.layer ?? this.publishInfoTable?.layer ?? this.publishInfoRaw?.layer
        },
    }
}
</script>
